import React from 'react';
import styled from 'styled-components';
import { COLORS, SPACING } from '../styles/constants';

const Card = styled.div`
  background-color: ${COLORS.white};
  border-radius: 8px;
  padding: ${SPACING.md} ${SPACING.md};
  display: flex;
  flex-direction: column;
  align-items: center;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
  transition: all 0.4s ease;
  height: 100%;
  border: 1px solid rgba(0, 0, 0, 0.05);
  position: relative;
  overflow: hidden;
  justify-content: space-between;
  text-align: center;
  
  &:hover {
    box-shadow: 0 12px 24px rgba(0, 0, 0, 0.15);
    transform: translateY(-8px);
  }
  
  &:before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 4px;
    height: 0;
    background-color: ${COLORS.primary};
    transition: height 0.4s ease;
  }
  
  &:hover:before {
    height: 100%;
  }
  
  &:after {
    content: '';
    position: absolute;
    bottom: 0;
    left: 0;
    width: 0;
    height: 4px;
    background-color: ${COLORS.primary};
    transition: width 0.4s ease 0.1s;
  }
  
  &:hover:after {
    width: 100%;
  }
`;

const IconContainer = styled.div`
  width: 60px;
  height: 60px;
  background-color: rgba(0, 144, 192, 0.1);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: ${SPACING.md};
  color: ${COLORS.primary};
  transition: all 0.4s ease;
  
  ${Card}:hover & {
    background-color: ${COLORS.primary};
    color: ${COLORS.white};
    transform: scale(1.1);
    box-shadow: 0 6px 16px rgba(0, 144, 192, 0.3);
  }
`;

const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  flex-grow: 1;
`;

const Title = styled.h3`
  font-size: 1.1rem;
  margin: 0 0 ${SPACING.md} 0;
  color: ${COLORS.dark};
  font-weight: 600;
  transition: color 0.3s ease;
  line-height: 1.4;
  
  ${Card}:hover & {
    color: ${COLORS.primary};
  }
`;

const LearnMoreButton = styled.button`
  background: transparent;
  border: 2px solid ${COLORS.primary};
  color: ${COLORS.primary};
  padding: 8px 16px;
  border-radius: 4px;
  font-size: 0.9rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  margin-top: auto;
  
  &:hover {
    background: ${COLORS.primary};
    color: white;
    transform: translateY(-2px);
  }
`;

const ServiceCard = ({ icon, title, onLearnMore, hideLearnMore = false }) => {
  return (
    <Card>
      <ContentWrapper>
        <IconContainer>
          {icon}
        </IconContainer>
        <Title>{title}</Title>
      </ContentWrapper>
      {!hideLearnMore && (
        <LearnMoreButton onClick={onLearnMore}>
          Learn More
        </LearnMoreButton>
      )}
    </Card>
  );
};

export default ServiceCard;